import { Navigate, useLocation } from 'react-router-dom';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector.js';
import LoginModal from 'components/LoginModal/index.js';
import './index.scss';

const RequireAuth = ({ type, redirectTo = '/login/person', children }) => {
    const from = useLocation();

    const app = useShallowEqualSelector(state => state.auth.app);
    const isAuthenticated = useShallowEqualSelector(state => state.auth.isAuthenticated);
    const isExpired = useShallowEqualSelector(state => state.auth.isExpired);

    if(isExpired) {
        return (
            <>
                <LoginModal type={type} />
                <div className='inert-wrap' inert='inert'>
                    {children}
                </div>
            </>
        );
    }

    if(!isAuthenticated || type !== app) return <Navigate to={redirectTo} state={{ from }} replace />;

    return children;
};

export default RequireAuth;
